import { createContext, type ReactNode, useContext } from "react";
import type { PageMetadata } from "~/app/api/pageData";

const PageMetadataContext = createContext<PageMetadata | undefined>(undefined);

export function PageMetadataProvider({ value, children }: { value: PageMetadata; children: ReactNode }) {
  return <PageMetadataContext.Provider value={value}>{children}</PageMetadataContext.Provider>;
}

export function usePageMetadata(): PageMetadata | undefined {
  return useContext(PageMetadataContext);
}

/**
 * PageMetadata.smartEdit is populated only when the current request carries CMS preview data.
 * Its presence is therefore the canonical current-page SmartEdit signal.
 */
export function useIsSmartEdit(): boolean {
  return Boolean(usePageMetadata()?.smartEdit);
}
